import jQuery from 'jquery';

window.jQuery = jQuery;
window.$ = jQuery;

/* eslint-disable no-unused-vars */
//import TaoVideoOverlay from '@tao/lib/TaoVideoOverlay';
/* eslint-enable */

export { jQuery };
